// extracted by mini-css-extract-plugin
export default {"container":"meA5Ga","horizontal":"ZgVgQO"};